import { MainConfig } from './mainconfig';
import { features } from './features';

import {
    language,
    dateStyle,
    timeZone
} from './language';

import {
    countries,
    default_country_code
} from './countries';

import {
    driverDatamart,
    driverFirebase,
    riderDatamart,
    riderFirebase
} from './deleteFields'

const AppDetails = MainConfig.AppDetails;
const FirebaseConfig = MainConfig.FirebaseConfig;
const Google_Map_Key = MainConfig.Google_Map_Key;
const facebookAppId = MainConfig.facebookAppId;
const PurchaseDetails = MainConfig.PurchaseDetails;
const guestRideDetailsUrl = MainConfig.GuestUrlRideDetails;
const iPhoneModelIdIsland = ['iPhone15,2', 'iPhone15,3'];
const mainUrl = "cloudfunctions.net";
const cloud_function_server_url = `https://us-central1-${FirebaseConfig.projectId}.${mainUrl}`;
const languageJson = language;

const fieldsDeleteDriverDatamart = driverDatamart;
const fieldsDeleteDriverFirebase = driverFirebase;
const fieldsDeleteRiderDatamart = riderDatamart;
const fieldsDeleteRiderFirebase = riderFirebase;
const weekDays = {
    es: [
        {
            value: 'monday',
            label: 'Lunes'
        },
        {
            value: 'tuesday',
            label: 'Martes'
        },
        {
            value: 'wednesday',
            label: 'Miércoles'
        },
        {
            value: 'thursday',
            label: 'Jueves'
        },
        {
            value: 'friday',
            label: 'Viernes'
        },
        {
            value: 'saturday',
            label: 'Sábado'
        },
        {
            value: 'sunday',
            label: 'Domingo'
        }
    ],
    en: [
        {
            value: 'monday',
            label: 'Monday'
        },
        {
            value: 'tuesday',
            label: 'Tuesday'
        },
        {
            value: 'wednesday',
            label: 'Wednesday'
        },
        {
            value: 'thursday',
            label: 'Thursday'
        },
        {
            value: 'friday',
            label: 'Friday'
        },
        {
            value: 'saturday',
            label: 'Saturday'
        },
        {
            value: 'sunday',
            label: 'Sunday'
        }
    ]
}


export {
    AppDetails,
    languageJson,
    FirebaseConfig,
    Google_Map_Key,
    PurchaseDetails,
    dateStyle,
    timeZone,
    facebookAppId,
    cloud_function_server_url,
    features,
    countries,
    default_country_code,
    mainUrl,
    guestRideDetailsUrl,
    iPhoneModelIdIsland,
    fieldsDeleteDriverDatamart,
    fieldsDeleteDriverFirebase,
    fieldsDeleteRiderDatamart,
    fieldsDeleteRiderFirebase,
    weekDays
}